import { authHeader, authHeaderMulti, handleResponse } from '../_helpers';

import { apiConstants } from '../_constants';

export const miscService = {
  fileupload,
  createSignedUploadUrl,
  b64toBlob,
  formatDate,
  formatTime,
  getParameterByName,
};

function createSignedUploadUrl(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(apiConstants.apiUrl + '/get_signed_upload_url', requestOptions).then(handleResponse);
}


function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;

  let byteCharacters = atob(b64Data);
  let byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    let slice = byteCharacters.slice(offset, offset + sliceSize);

    let byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    let byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  let blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

async function fileupload(file, name) {
  console.log(file, name);
  let data = new FormData();
  data.append("file", file, name);
  data.append("name", "filename");
  const requestOptions = {
    method: "POST",
    body: data,
    headers: await authHeaderMulti(),
  };
  return fetch(apiConstants.apiUrl + "/fileupload", requestOptions).then(
    handleResponse
  );
}



function formatDate(date) {
  let d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [day, month, year].join('/');
}

function formatTime(date) {
  let d = new Date(date),
    hours = d.getHours(),
    minutes = '' + d.getMinutes(),
    a = ' AM';

  if (hours > 12) {
    hours = '' + hours - 12;
    a = ' PM';
  } else if (hours === 0) {
    hours = '12';
  } else {
    hours = '' + hours;
  }

  if (minutes.length < 2) minutes = '0' + minutes;

  return hours + ':' + minutes + a;
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export async function validateFileSize(fileSize) {
  const fileSizeInMB = fileSize / 1024 / 1024;
  console.log("filesize----", fileSize, "fileSizeInMB", fileSizeInMB);
  if (fileSizeInMB > 2) {
    return false;
  }
  return true;
}

export function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function getLast4Digits(number) {
  const numberString = number.toString();
  return numberString.slice(-4);
}

export function Capitalize(str) {
  if (str) {
    return str.charAt(0).toUpperCase();
  }
}

export const isNotExpired = (timestamp) => {
  let expiryDate = new Date(Number(timestamp));

  let currentDate = new Date();

  // Calculate difference in days of expiry date and current date
  let differenceInMilliseconds = expiryDate.getTime() - currentDate.getTime();
  let differenceInDays = Math.floor(
    differenceInMilliseconds / (1000 * 60 * 60 * 24)
  );
  if (differenceInDays < 0) {
    return false;
  }
  return true;
};

export function trimString(string, limit) {
  if (string?.length > limit) {
    return string.substring(0, limit) + '...';
  }
  return string;
}

export const secondsToHHMM = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

export const millisecondsToHHMMSS = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  const timeParts = [];
  if (hours > 0) timeParts.push(`${hours} Hour${hours > 1 ? 's' : ''}`); // Singular or plural for hours
  if (minutes > 0) timeParts.push(`${minutes} Minute${minutes > 1 ? 's' : ''}`); // Singular or plural for minutes
  if (seconds > 0) timeParts.push(`${seconds} Second${seconds > 1 ? 's' : ''}`); // Singular or plural for seconds

  return timeParts.join(' ');
};

// Return user name abbreviation
export const userAbb = (name) => {
  let abbName =
    name.trim()?.toString()?.split(' ').length > 1
      ? `${name.toString().split(' ')[0].charAt(0).toUpperCase()}${name
        .toString()
        ?.split(' ')[1]
        .charAt(0)
        .toUpperCase()}`
      : `${name.toString().slice(0, 2).toUpperCase()}`;

  return abbName;
};
